

import React, { Component } from "react";
import Button from "../components/bases/button/button";
import imgDelete from "./assets/delete.png"

class TaskStatus extends Component {
  handleClick = () => {
    const { onClick, id } = this.props;

    if (onClick) {
      onClick(id);
    }
  };

  formatDate = (value) => {
    if (!value || value.length !== 8) return "";

    // Format reçu : AAAAJJMM
    // Exemple : 20251407 => 14/07/2025

    const year = value.substring(0, 4);
    const day = value.substring(4, 6);
    const month = value.substring(6, 8);

    return `${day}/${month}/${year}`;
  };

  renderContent() {
    const { status, text, pourcent, error } = this.props;

    // Erreur
    if (status === -1 || error) {
      return (
        <div style={styles.errorText}>
          {text}
        </div>
      );
    }

    // Progression
    if (status === 1) {
      return (
        <div style={styles.progressWrapper}>
          <div style={styles.progressBackground}>
            <div
              style={{
                ...styles.progressBar,
                width: `${pourcent}%`,
              }}
            />
          </div>

          <span style={styles.progressText}>
            {pourcent}%
          </span>
        </div>
      );
    }

    // Texte normal
    return (
      <div style={styles.normalText}>
        {text}
      </div>
    );
  }

  render() {
    const { id, title, date } = this.props;

    return (
      <div style={styles.card}>
        <div style={styles.left}>
          <div style={styles.topRow}>
            <div style={styles.title}>
              {id} - {title}
            </div>

            <div style={styles.date}>
              
            </div>
          </div>

          <div style={styles.content}>
            {this.renderContent()}
          </div>
        </div>

        <Button 
        button={true}
        image={imgDelete}
        tooltip={{"fr":"Supprimer","en":"Delete"}}
        disable={false}
        datas={this.props.id}
        onClick={this.handleClick}
        height={20} width={20}/>
      </div>
    );
  }
}

const styles = {
  card: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    background: "#1f2430",
    border: "1px solid #353c4e",
    borderRadius: 10,
    padding: "10px 12px",
    marginBottom: 8,
    boxShadow: "0 2px 6px rgba(0,0,0,0.25)",
    fontFamily: "Arial, sans-serif",
    minHeight: 68,
  },

  left: {
    flex: 1,
    marginRight: 10,
  },

  topRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 6,
  },

  title: {
    fontSize: 14,
    fontWeight: "bold",
    color: "#f1f1f1",
    marginRight: 3,
  },

  date: {
    fontSize: 11,
    color: "#9aa4b2",
  },

  content: {
    width: "100%",
  },

  normalText: {
    fontSize: 12,
    color: "#c7d0dd",
  },

  errorText: {
    fontSize: 12,
    color: "#ff6b6b",
    fontWeight: "bold",
  },

  progressWrapper: {
    display: "flex",
    alignItems: "center",
    gap: 8,
  },

  progressBackground: {
    flex: 1,
    height: 10,
    backgroundColor: "#394255",
    borderRadius: 10,
    overflow: "hidden",
  },

  progressBar: {
    height: "100%",
    background: "linear-gradient(90deg, #2f80ed, #56ccf2)",
    borderRadius: 10,
    transition: "width 0.3s ease",
  },

  progressText: {
    fontSize: 11,
    color: "#dce3ec",
    minWidth: 34,
    textAlign: "right",
    fontWeight: "bold",
  },

};

export default TaskStatus;